// List
export const CHAT_GET_USER_CHATS_REQUEST = "CHAT_GET_USER_CHATS_REQUEST";
export const CHAT_GET_USER_CHATS_SUCCESS = "CHAT_GET_USER_CHATS_SUCCESS";
export const CHAT_GET_USER_CHATS_FAIL = "CHAT_GET_USER_CHATS_FAIL";

// Single chat + messages
export const CHAT_GET_CHAT_BY_ID_REQUEST = "CHAT_GET_CHAT_BY_ID_REQUEST";
export const CHAT_GET_CHAT_BY_ID_SUCCESS = "CHAT_GET_CHAT_BY_ID_SUCCESS";
export const CHAT_GET_CHAT_BY_ID_FAIL = "CHAT_GET_CHAT_BY_ID_FAIL";

// Send message
export const CHAT_SEND_MESSAGE_REQUEST = "CHAT_SEND_MESSAGE_REQUEST";
export const CHAT_SEND_MESSAGE_SUCCESS = "CHAT_SEND_MESSAGE_SUCCESS";
export const CHAT_SEND_MESSAGE_FAIL = "CHAT_SEND_MESSAGE_FAIL";
export const CHAT_VOICE_UPLOAD_COMPLETE = "CHAT_VOICE_UPLOAD_COMPLETE";

// Edit / delete message
export const CHAT_EDIT_MESSAGE_SUCCESS = "CHAT_EDIT_MESSAGE_SUCCESS";
export const CHAT_DELETE_MESSAGE_SUCCESS = "CHAT_DELETE_MESSAGE_SUCCESS";
export const CHAT_BULK_DELETE_MESSAGES_SUCCESS = "CHAT_BULK_DELETE_MESSAGES_SUCCESS";

// Real-time socket events
export const CHAT_NEW_MESSAGE = "CHAT_NEW_MESSAGE";
export const CHAT_NEW_CHAT_REQUEST = "CHAT_NEW_CHAT_REQUEST";
export const CHAT_REQUEST_ACCEPTED = "CHAT_REQUEST_ACCEPTED";
export const CHAT_REQUEST_REJECTED = "CHAT_REQUEST_REJECTED";
export const CHAT_MESSAGE_LIKED = "CHAT_MESSAGE_LIKED";
export const CHAT_MESSAGE_REACTION = "CHAT_MESSAGE_REACTION";
export const CHAT_REMOTE_SEEN = "CHAT_REMOTE_SEEN";

// Selection & UI
export const CHAT_SELECT_CHAT = "CHAT_SELECT_CHAT";
export const CHAT_LEAVE_ROOM = "CHAT_LEAVE_ROOM";
export const CHAT_SET_TYPING = "CHAT_SET_TYPING";
export const CHAT_ACTIVE_TAB = "CHAT_ACTIVE_TAB"; // "chat" | "files" | "pinned"
export const CHAT_RESET = "CHAT_RESET";

// Create / accept / reject
export const CHAT_CREATE_REQUEST_REQUEST = "CHAT_CREATE_REQUEST_REQUEST";
export const CHAT_CREATE_REQUEST_SUCCESS = "CHAT_CREATE_REQUEST_SUCCESS";
export const CHAT_CREATE_REQUEST_FAIL = "CHAT_CREATE_REQUEST_FAIL";
export const CHAT_ACCEPT_REQUEST_SUCCESS = "CHAT_ACCEPT_REQUEST_SUCCESS";
export const CHAT_REJECT_REQUEST_SUCCESS = "CHAT_REJECT_REQUEST_SUCCESS";

// Mark seen
export const CHAT_MARK_SEEN_SUCCESS = "CHAT_MARK_SEEN_SUCCESS";

// Pin / unpin message
export const CHAT_PIN_MESSAGE_SUCCESS = "CHAT_PIN_MESSAGE_SUCCESS";
export const CHAT_UNPIN_MESSAGE_SUCCESS = "CHAT_UNPIN_MESSAGE_SUCCESS";

// Search users by username (new collaboration)
export const CHAT_SEARCH_USERS_REQUEST = "CHAT_SEARCH_USERS_REQUEST";
export const CHAT_SEARCH_USERS_SUCCESS = "CHAT_SEARCH_USERS_SUCCESS";
export const CHAT_SEARCH_USERS_FAIL = "CHAT_SEARCH_USERS_FAIL";
export const CHAT_SEARCH_USERS_CLEAR = "CHAT_SEARCH_USERS_CLEAR";

// Voice/Video call (1:1)
export const CHAT_CALL_INCOMING = "CHAT_CALL_INCOMING";
export const CHAT_CALL_ACCEPTED = "CHAT_CALL_ACCEPTED";
export const CHAT_CALL_REJECTED = "CHAT_CALL_REJECTED";
export const CHAT_CALL_CANCELED = "CHAT_CALL_CANCELED";
export const CHAT_CALL_DISMISS = "CHAT_CALL_DISMISS";
export const CHAT_CALL_OUTGOING_STATUS = "CHAT_CALL_OUTGOING_STATUS";
export const CHAT_ACTIVE_CALL_SET = "CHAT_ACTIVE_CALL_SET";
export const CHAT_ACTIVE_CALL_CLEAR = "CHAT_ACTIVE_CALL_CLEAR";
export const CHAT_CALL_OUTGOING_TYPE = "CHAT_CALL_OUTGOING_TYPE";

/** Site-wide peer online flags (1:1 accepted chat peers), keyed by user id string */
export const CHAT_PRESENCE_UPDATE = "CHAT_PRESENCE_UPDATE";
export const CHAT_PRESENCE_MERGE = "CHAT_PRESENCE_MERGE";

/** Last online timestamps for offline accepted-chat peers */
export const CHAT_LAST_ONLINE_UPDATE = "CHAT_LAST_ONLINE_UPDATE";

/** Set per-chat unread counts from server push */
export const CHAT_SET_UNREAD_COUNTS = "CHAT_SET_UNREAD_COUNTS";

/** Bulk (multi-select) list actions */
export const CHAT_BULK_MARK = "CHAT_BULK_MARK"; // { chatIds, read }
export const CHAT_BULK_MUTE = "CHAT_BULK_MUTE"; // { chatIds, mute }
export const CHAT_BULK_REMOVE = "CHAT_BULK_REMOVE"; // { chatIds }

// Older messages (infinite scroll upward)
export const CHAT_LOAD_OLDER_MESSAGES_REQUEST = "CHAT_LOAD_OLDER_MESSAGES_REQUEST";
export const CHAT_LOAD_OLDER_MESSAGES_SUCCESS = "CHAT_LOAD_OLDER_MESSAGES_SUCCESS";
export const CHAT_LOAD_OLDER_MESSAGES_FAIL = "CHAT_LOAD_OLDER_MESSAGES_FAIL";
